export const listJobsForWorkspace = /* GraphQL */ `
  query ListJobsByWorkspaceId(
    $workspaceId: String
    $sk: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelJobFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listJobsByWorkspaceId(
      workspaceId: $workspaceId
      sk: $sk
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        sk
        type
        data
        status
        percentComplete
        jobPartCount
        jobPartCompleteCount
        startedAt
        completedAt
        creatorId
        name
        outputFile {
          region
          bucket
          key
        }
        params
        creator {
          id
          sk
          firstName
          lastName
          email
          avatarHash
          acl
          userId
        }
        workspaceId
        parentJobId
        parentJob {
          id
          sk
          type
          data
          status
          percentComplete
          creatorId
          creator {
            id
            sk
            firstName
            lastName
            email
            avatarHash
            acl
            userId
          }
          workspaceId
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const createJob = /* GraphQL */ `
  mutation CreateJob($input: CreateJobInput!) {
    createJob(input: $input) {
      id
      sk
    }
  }
`;
